import React, { useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { GetBaseUrl } from "./getBaseUrl";
import { useNavigate } from 'react-router-dom';

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export default function BreadCrumbComponent(props) {
  const [bC, setBC] = useState([]);
  const navigate = useNavigate()

  const getHome = (item) => {
    if (item === "Home") {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url);
      navigate("/");

    } else if (item === "Help") {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(
      //   url +
      //     "/application/help"
      // );
      navigate(
        url +
          "/application/help"
      );
    }
    else if (item === "Queries") {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(
      //   url +
      //     "/application/help/view-queries"
      // );
      navigate("/application/help/view-queries");
    }
  };
  const getBC = () => {
    let modifiedList = props.list.map((item, index) => {
      if (index + 1 === props.list?.length) {
        return (
          <Typography className="md-desc" key="3" color="#9B1E26">
            {item}
          </Typography>
        );
      } else {
        return (
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href={
              item === "View Queries"
                ? "/view-queries"
                : item === "Raise a Query"
                ? "/view-queries"
                : '/'
            }
            onClick={handleClick}
          >
            <div className="instructions" onClick={() => getHome(item)}>
              {item}
            </div>
          </Link>
        );
      }
    });
    setBC([...modifiedList]);

    console.log("modifiedList", modifiedList);
  };

  useEffect(() => {
    getBC();
  }, []);
  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {bC}
      </Breadcrumbs>
    </Stack>
  );
}
